const buttons = document.querySelectorAll(".collectionTextList__button");

// 各質問にマウスオーバーとマウスアウトのイベントを設定
buttons.forEach(function (button) {
  const target = button.nextElementSibling;

  // マウスオーバーで回答を開く
  button.addEventListener("click", function () {
    this.classList.toggle("is-active");
    const target = this.nextElementSibling;
    if (target.style.maxHeight) {
      target.style.maxHeight = null;
    } else {
      target.style.maxHeight = target.scrollHeight + "px";
    };
  });
});
